import { baseURL } from "./baseUrl";
import { cachedRequest, requestKey } from "./requestCache";

// How long a successful multi_filter result is reused for an identical body.
// Matches the product page's query staleTime.
const MULTI_FILTER_TTL_MS = 60 * 1000;

// Every multi_filter caller (listing grid, search, product page, collection
// designs) goes through here, so identical bodies are sent once.
export const apiFilterProducts = (filters: object) =>
  cachedRequest(requestKey("multi_filter", filters), MULTI_FILTER_TTL_MS, async () => {
    const response = await baseURL.post(`products/multi_filter`, filters, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  });

export const apiProductProperties = async (filters: object) => {
  const response = await baseURL.post(`/products/stats`, filters, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const apiGetProductItemCount = async (filters: object) => {
  const response = await baseURL.post(`/products/stats`, filters, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
